import { useEffect, useState } from "react";
import FamLogoLoader from "../../components/FamLogoLoader";
import { LOVABLE_IFRAME_URL } from "../../utils/appStore";
import "./LovableIframePage.scss";

const LovableIframePage = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const isLoading = !iframeLoaded || !animationComplete;

  useEffect(() => {
    document.body.classList.add("lovable-iframe-page");
    return () => {
      document.body.classList.remove("lovable-iframe-page");
    };
  }, []);

  return (
    <div className="lovable-iframe-page__shell">
      {isLoading && (
        <div className="lovable-iframe-page__loading" aria-live="polite">
          <FamLogoLoader onAnimationComplete={() => setAnimationComplete(true)} />
        </div>
      )}
      <iframe
        src={LOVABLE_IFRAME_URL}
        title="FAM — For All Milestones"
        className="lovable-iframe-page__frame"
        onLoad={() => setIframeLoaded(true)}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default LovableIframePage;
